export default {
  ARTIST: 'artists',
  TRACK: 'tracks',
  RECENT: 'recently',
  RELATED_ARTISTS: 'relatedArtists',
  RECOMMENDED_ARTISTS: 'recommendedArtists',
  RELATED_TRACKS_ARTISTS: 'tracksRelatedArtists',
  RECOMMENDED_TRACKS: 'recommendedTracks',
};



// WEBPACK FOOTER //
// ./src/constants/PlaylistTypes.js